import * as Yup from 'yup';

export const KycDirectorOneSchema = Yup.object().shape({
  // taxIdentificationNumber: Yup.string()
  //   .min(1, 'Tax Identification Number is required')
  //   .required('Please provide your Tax Identification Number'),
  directorOneName: Yup.string()
    .min(1, 'Tax Identification Number is required')
    .required('Please provide your Tax Identification Number'),
  directorOneIdentificationType: Yup.string()
    .min(1, 'Identification Type is required')
    .required('Please provide your Identification Type'),
  directorOneId: Yup.array()
    .required('Please add an attachment')
    .min(1, 'Please upload at least one file')
    // .max(3, 'You can only upload up to 3 files')
    .of(
      Yup.mixed<File>()
        .test('fileType', 'Unsupported file format', (file: File | undefined) =>
          file
            ? [
              'application/pdf',
              'application/msword',
              'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            ].includes(file.type)
            : false
        )
        .test(
          'fileSize',
          'File size too large (Max: 15MB)',
          (file: File | undefined) =>
            file ? file.size <= 15 * 1024 * 1024 : false
        )
    ),
});

export type KycDirectorOneDataType = Yup.InferType<typeof KycDirectorOneSchema>;

type InitialValues = {
  directorOneName: string;
  directorOneIdentificationType: string;
  directorOneId: File[];
};

export const kycDirectorOneInitialValues: InitialValues = {
  directorOneName: '',
  directorOneIdentificationType: '',
  directorOneId: [],
};


export interface KycDirectorOneInterface {
  directorOneName: string;
  directorOneIdentificationType: string;
  directorOneId: File[];
};

